module.exports = __webpack_public_path__ + "static/img/oca-report.adb0526.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/visual-marketing/oca-report.jpg
// module id = F/RA
// module chunks = 0